import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import DialogCommon from '../../components/dialogCommon';
import InputCommon from '../../components/inputCommon';
import NavCommon from '../../components/navCommon';
import {
  Container, SizedBox,
} from './styles';
import SpecialistAPI from '../../services/enterprise/index';
import { InterPrise, Specialist } from '../../interfaces';
import AvatarAndName from '../../components/avatarAndName';
import InputFileCommon from '../../components/inputFileCommon';
import TableCommon from '../../components/tableCommon';
import SelectComponent from './component/select';

const Enterprises = () => {
  const history = useHistory();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [nameEnterprise, setNameEntreprise] = useState<string>('');
  const [specialists, setSpecialist] = useState<Array<Specialist>>([]);
  const [
    specialistSelect,
    setSpecialistSelect] = useState<Array<{ label: string, value: string }>>([]);
  const [openList] = useState<boolean>(false);
  const [photoBase64, setPhotoBase64] = useState<string>('');
  const [nameFile, setNameFile] = useState<string>('');
  const [enterprises, setEnterprises] = useState<Array<InterPrise>>([]);
  const [enterprisesToSelect,
    setEnterprisesToSelect] = useState<Array<{label: string, value: string}>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [hasPhoto, setHasPhoto] = useState<boolean>(false);
  const [idEnterprise, setIdEnterprise] = useState<string>('');
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [specialistSelected, setSpecialistSelected] = useState({ selecteds: [] });

  const requestGetSpecialist = async () => {
    try {
      setLoading(true);
      const data = await SpecialistAPI.GetSpecialist();
      setSpecialist(data);
      const newData = data.map((item: { nome: string, id: string }) => ({
        label: item.nome,
        value: item.id,
      }));
      setSpecialistSelect(newData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const filterImg = (img: String) => {
    if (img.includes('jpeg')) {
      return img.replace('data:image/jpeg;base64,', '');
    }
    if (img.includes('png')) {
      return img.replace('data:image/png;base64,', '');
    }
    return '';
  };

  const saveOrEdit = async () => {
    try {
      if (isEdit) {
        setLoadingSave(true);
        const response = await SpecialistAPI.updateEnterprise(
          idEnterprise,
          nameEnterprise,
          nameFile,
          photoBase64.includes('base64') ? filterImg(photoBase64) : '',
          specialistSelected.selecteds.map((item: { label: string, value: string }) => item.value),
        );
        setEnterprises(
          enterprises.map((item: InterPrise) => {
            if (item.idEmpreendimento === response.idEmpreendimento) {
              item.nome = response.nomeEmpreendimento;
              item.empreendimentoAtivo = true;
              item.urlImagem = response.urlImagem;
              item.usuarios = response.usuarios
                .map((it: { id: string; nome: string; }) => ({
                  idUsuario: it.id,
                  nome: it.nome,
                }));
              return item;
            }
            return item;
          }),
        );
        setLoadingSave(false);
        setOpenModal(false);
        setIsEdit(false);
        setHasPhoto(false);
        setNameEntreprise('');
        setNameFile('');
        setPhotoBase64('');
        setIdEnterprise('');
        setSpecialistSelected({ selecteds: [] });
        toast.success('Empreendimento atualizado com sucesso');
        return;
      }
      if (
        !nameEnterprise
        || !photoBase64) {
        toast.error('O campo nome, foto e especialistas são obrigatório');
        return;
      }

      setLoadingSave(true);

      const response = await SpecialistAPI.createEnterprise(
        nameEnterprise,
        nameFile,
        filterImg(photoBase64),
        specialists.filter((item) => item.check).map((item) => item.id),
      );

      const data: InterPrise = {
        nome: response.nomeEmpreendimento,
        empreendimentoAtivo: true,
        urlImagem: response.urlImagem,
        usuarios: response.usuarios
          .map((it: { id: string; nome: string; }) => ({
            idUsuario: it.id,
            nome: it.nome,
          })),
        idEmpreendimento: response.idEmpreendimento,
      };

      setLoadingSave(false);
      setEnterprises((state) => [...state, data]);
      clearState();
      toast.success('Empreendimento criado com sucesso');
    } catch (error: any) {
      setLoadingSave(false);
      toast.error(`⚠ ${error?.response.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
    }
  };

  const clearState = () => {
    setNameFile('');
    setPhotoBase64('');
    setNameEntreprise('');
    setOpenModal(false);
    setSpecialist(specialists.map((item) => {
      item.check = false;
      return item;
    }));
  };

  const requestEnterprise = async () => {
    const response = await SpecialistAPI.GetEnterprise();

    setEnterprisesToSelect(response?.map((it: any) => ({
      label: it.nome,
      value: it.idEmpreendimento,
    })));
    setEnterprises(response);
  };

  const inactiveEnterprise = async (id: string) => {
    try {
      await SpecialistAPI.disableEnterprise(id);
      setEnterprises(enterprises.map((item) => {
        if (item.idEmpreendimento === id) {
          item.empreendimentoAtivo = false;
          return item;
        }
        return item;
      }));
      toast.success('Empreendimento desativado com sucesso');
    } catch (error) {
      toast.error('Erro ao desativar empreendimento');
    }
  };

  const activeEnterprise = async (id: string) => {
    try {
      await SpecialistAPI.enableEnterprise(id);
      setEnterprises(enterprises.map((item) => {
        if (item.idEmpreendimento === id) {
          item.empreendimentoAtivo = true;
          return item;
        }
        return item;
      }));
      toast.success('Empreendimento ativado com sucesso');
    } catch (error) {
      toast.error('Erro ao ativar empreendimento');
    }
  };

  const enterpriseFilter = async (enterPrise: any, ids: any) => {
    try {
      if (enterPrise.length === 0
      && ids.length === 0) {
        toast.info('Selecione pelo menos uma opção do filtro');
        return;
      }
      setLoading(true);
      const enterprise = await SpecialistAPI.GetEnterpriseFilter(
        enterPrise.map((item: any) => item.value).length > 0
          ? enterPrise.map((item: any) => item.value) : null,
        ids.map((item: any) => item.value).length > 0 ? ids.map((item: any) => item.value) : null,
      );
      setEnterprises(enterprise);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Erro ao ativar ao realizar filtro');
    }
  };

  const onEdit = (item: {
    empreendimentoAtivo: boolean,
    idEmpreendimento: string,
    nome: string,
    urlImagem: string,
    usuarios: Array<{ idUsuario: string, nome: string }>,
  }) => {
    setIsEdit(true);
    setOpenModal(true);
    setNameEntreprise(item?.nome);
    setPhotoBase64(item?.urlImagem);
    setIdEnterprise(item.idEmpreendimento);
    setSpecialistSelected({
      // @ts-ignore
      selecteds: item.usuarios.map((it) => ({
        label: it.nome,
        value: it.idUsuario,
      })),
    });

    setHasPhoto(true);
    setSpecialist(
      specialists.map((it) => {
        item.usuarios.map(((el: any) => {
          if (it.id === el.idUsuario) {
            it.check = !it.check;
            return el;
          }
          return el;
        }));
        return it;
      }),
    );
  };

  const onClose = () => {
    setIsEdit(false);
    setHasPhoto(false);
    setNameEntreprise('');
    setNameFile('');
    setPhotoBase64('');
    setIdEnterprise('');
    setSpecialistSelected({ selecteds: [] });
  };

  const onClean = () => {
    requestEnterprise();
  };

  useEffect(() => {
    requestGetSpecialist();
    requestEnterprise();
  }, []);

  const form = () => (
    <>
      <SizedBox style={{ marginTop: 10 }} />
      <InputFileCommon
        hasPhoto={hasPhoto}
        setHasPhoto={setHasPhoto}
        onChange={setPhotoBase64}
        onChangeFileName={setNameFile}
        photo={photoBase64}
      />
      <SizedBox />
      <InputCommon
        isDisabled={false}
        isError={false}
        type="text"
        placeholder="Nome"
        value={nameEnterprise}
        onChange={setNameEntreprise}
      />
      <SizedBox />
      <SelectComponent
        data={specialistSelect}
        isMultiple
        updateValue={setSpecialistSelected}
        onChange={(event: any) => {
          event.persist();
          setSpecialistSelected((formState) => ({
            ...formState,
            [event.target.name]:
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value,
          }));
        }}
        value={specialistSelected.selecteds}
        label="Especialistas"
      />
      <SizedBox />
      {openList ? (
        <AvatarAndName setData={setSpecialist} data={specialists} />
      ) : null}
    </>
  );
  return (
    <Container>
      <NavCommon
        breadcrumbs={[
          { path: '', name: 'Empreendimentos' },
        ]}
        hasOnChange
        onBack={() => { history.goBack(); }}
        onChange={setOpenModal}
      />
      <DialogCommon
        title={isEdit ? 'Edição de empreendimento' : 'Novo emprendimento'}
        open={openModal}
        setOpenModal={setOpenModal}
        component={form()}
        saveText="Salvar"
        closeText="Fechar"
        onClose={onClose}
        isFilter={false}
        onClean={onClean}
        loading={loadingSave}
        onSave={() => {
          saveOrEdit();
        }}
      />
      <TableCommon
        isMultiple
        onEdit={onEdit}
        onClean={() => {
          requestEnterprise();
        }}
        onSave={(enterpriseIDS: any, ids: any) => {
          enterpriseFilter(enterpriseIDS, ids);
        }}
        hasFilter
        selectData={specialists.map((item) => ({
          label: item.nome,
          value: item.id,
        }))}
        isLoading={loading}
        activeOrIncactiveLocal={() => {}}
        inactiveEnterprise={inactiveEnterprise}
        activeEnterprise={activeEnterprise}
        isEnterprise
        title="Empreendimentos"
        titleFirstSelect="Empreendimentos"
        titleSecondSelect="Especialistas"
        isSpecialist
        data={enterprises}
        setFirstSelect={() => {}}
        setSecondSelect={() => {}}
        enterPriseData={enterprisesToSelect || []}
      />
    </Container>
  );
};
export default Enterprises;
